<template>
	<v-card class="mt-3 ma-2">
		<v-toolbar :color="color" dark>
			<v-toolbar-title class="no-print">{{ header }}</v-toolbar-title>
			<h3 class="d-none print-only ma-2 black--text">{{ header }} </h3>
			<v-spacer></v-spacer>
		</v-toolbar>

		<v-list two-line>
			<v-list-tile v-for="item in documents" :key="item.id" avatar class="protocol-document-list-item">
				<v-list-tile-avatar>
					<v-icon>assignment</v-icon>
				</v-list-tile-avatar>

				<v-list-tile-content>
					<v-list-tile-title>{{item.fileName}}</v-list-tile-title>
					<v-list-tile-sub-title v-if="item.creationDate">{{displayDateTime(item.creationDate)}}</v-list-tile-sub-title>
				</v-list-tile-content>

				<v-list-tile-action class="no-print">
					<EgrantyIconButton 
						@click="downloadFile(item)" 
						icon="cloud_download" 
						color="primary" 
						label="pobierz"
					/>
				</v-list-tile-action>
			</v-list-tile>
		</v-list>
	</v-card>
</template>

<script>
	import {Dates} from "@/utils/Dates";
	import {Files} from "@/utils/Files";
	import EgrantyIconButton from "@/genericComponents/EgrantyIconButton";

	export default {
		name: "LibraryListReadOnly",

		components: {
			EgrantyIconButton
		},

		data() {
			return {};
		},

		props: {
			color: String,
			header: String,
			documents: Array
		},

		methods: {
			downloadFile(file) {
				// Implementacja pobierania pliku dla użytkownika tylko do odczytu
				this.downloadLibraryFile(this, file.id, file.fileName);
			},
		},

		mixins: [
			Dates,
			Files,
		],
	};
</script>

<style scoped>
	.theme--dark .v-toolbar {
		background-color: #0052a5 !important;
	}
	.theme--dark .v-list__tile__action-text {
		color: #fff;
	}
	.theme--dark .red--text.text--lighten-1 {
		color: yellow !important;
	}
</style>